var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "v-card",
        [
          _c("v-card-title", [
            _vm._v(
              " " +
                _vm._s(
                  _vm.editing
                    ? "Editar configuración de alianza"
                    : "Configuración de alianza"
                ) +
                " "
            ),
          ]),
          _c(
            "v-card-text",
            [
              _c(
                "v-form",
                { ref: "form" },
                [
                  _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "12", md: "4" } },
                        [
                          _c("v-select", {
                            attrs: {
                              items: _vm.filteredClients,
                              rules: [_vm.requiredRule],
                              "item-text": "text",
                              "item-value": "IdCompania",
                              label: "Compañía",
                              "prepend-inner-icon": "mdi-sitemap",
                              disabled: _vm.editing,
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "prepend-item",
                                fn: function () {
                                  return [
                                    _c(
                                      "v-list-item",
                                      [
                                        _c(
                                          "v-list-item-content",
                                          [
                                            _c("v-text-field", {
                                              attrs: {
                                                "hide-details": "",
                                                placeholder: "Buscar",
                                                "prepend-inner-icon":
                                                  "mdi-magnify",
                                              },
                                              model: {
                                                value: _vm.search,
                                                callback: function ($$v) {
                                                  _vm.search = $$v
                                                },
                                                expression: "search",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                                proxy: true,
                              },
                            ]),
                            model: {
                              value: _vm.form.IdCompania,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "IdCompania", $$v)
                              },
                              expression: "form.IdCompania",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { attrs: { cols: "12", md: "4" } },
                        [
                          _c("v-select", {
                            attrs: {
                              items: _vm.availableAlianzas,
                              rules: [_vm.requiredRule],
                              "item-text": "NombreAlianza",
                              "item-value": "CodigoAlianza",
                              label: "Alianza",
                              "prepend-inner-icon": "mdi-handshake",
                              disabled: _vm.editing,
                            },
                            on: { change: _vm.changeAlianza },
                            model: {
                              value: _vm.form.CodigoAlianza,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "CodigoAlianza", $$v)
                              },
                              expression: "form.CodigoAlianza",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm.selectedAlianzaComponent
                    ? _c(
                        "v-row",
                        [
                          _c(
                            "v-col",
                            { attrs: { cols: "12" } },
                            [
                              _c(_vm.selectedAlianzaComponent, {
                                tag: "component",
                                model: {
                                  value: _vm.form.DataIntegration,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "DataIntegration", $$v)
                                  },
                                  expression: "form.DataIntegration",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        {
                          staticClass: "d-flex justify-end",
                          attrs: { cols: "12" },
                        },
                        [
                          _vm.editing
                            ? _c(
                                "v-btn",
                                {
                                  staticClass: "mr-3",
                                  attrs: { text: "" },
                                  on: { click: _vm.resetForm },
                                },
                                [_vm._v(" CANCELAR ")]
                              )
                            : _vm._e(),
                          _vm.form.CodigoAlianza
                            ? _c(
                                "v-btn",
                                {
                                  staticStyle: {
                                    "background-color": "rgb(204 33 40)",
                                    color: "white !important",
                                  },
                                  attrs: {
                                    dark: "",
                                    "min-width": "220",
                                    height: "45",
                                  },
                                  on: { click: _vm.save },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.editing ? "ACTUALIZAR" : "GUARDAR"
                                      ) +
                                      " "
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "v-alert",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.successAlert,
                          expression: "successAlert",
                        },
                      ],
                      staticClass: "mb-4",
                      attrs: { type: "success", text: "" },
                    },
                    [_vm._v(" " + _vm._s(_vm.msgSuccessAlert) + " ")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }